import { connect } from 'react-redux';
import { HorizontalToggle } from '@hc/component-lib/hclib/components/atoms/horizontal-toggle';
import classNames from 'classnames';

import { PREFERENCES_KEYS } from 'legacy/appstore/constants';

import { preferencesSave } from 'actions/preferences';

import { getCompsListViewSelected } from 'selectors/comps-context';
import { getPreferencesMaps } from 'selectors/preferences';

import { MapControlClusters as theme } from 'legacy/css-modules';

const mapStateToProps = (state, ownProps) => {
  const preferences = getPreferencesMaps(state);
  return {
    options: [
      {
        label: 'Cluster On',
        value: false
      },
      {
        label: 'Cluster Off',
        value: true
      }
    ],
    value: !!preferences.disableClusters,
    className: classNames(theme.MapControlClusters, {
      [theme.hidden]: getCompsListViewSelected(state)
    }),
    theme
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSelect: (disableClusters) =>
      dispatch(
        preferencesSave({
          [PREFERENCES_KEYS.MAPS]: { disableClusters }
        })
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HorizontalToggle);
